import * as React from "react";
import { BellRing, Database, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const features = [{
  title: "The Legacy Markup",
  description: "Most IT providers add a 20-30% 'tax' on your Microsoft 365 seats. We believe startups shouldn't pay a premium just for license procurement.",
  icon: BellRing,
  colorClass: "text-destructive bg-destructive/10"
}, {
  title: "Straight-Through Pricing",
  description: "Access O365 Business Premium, E3, or E5 at our direct cost with $0 markup. We pass the savings to you as your long-term growth partner.",
  icon: ShieldCheck,
  colorClass: "text-primary bg-primary/10"
}, {
  title: "Management Included",
  description: "Full O365 support and administration are already bundled into our flat $110/device base fee. No hidden support line items, ever.",
  icon: Database,
  colorClass: "text-chart-3 bg-chart-3/10"
}];
export default function PortalBenefits() {
  return <section data-section-id="221916" id="o365-without-the-tax" className="w-full bg-background py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <Card key={i} data-index={i} className="border-border/50 bg-card/40 shadow-sm backdrop-blur-sm transition-all hover:shadow-md dark:bg-card/40">
              <CardHeader className="pb-4">
                <div className={`mb-4 flex size-12 items-center justify-center rounded-xl ${feature.colorClass}`}>
                  <feature.icon className="size-6" />
                </div>
                <CardTitle className="font-default text-xl font-semibold text-foreground">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-default text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}